// types
import { SaveModeStateSchema } from "../types/saveModeTypes";

export const getSaveModeState = (state: SaveModeStateSchema) => state.saveMode;
